"use client";

import Link from "next/link";
import { usePathname } from "next/navigation";
import { DataRefreshButton } from "@/components";
import { MAIN_NAV } from "@/constants/nav";

export function SecondaryFooter() {
  const pathname = usePathname();

  if (pathname.startsWith("/auth")) {
    return null;
  }

  return (
    <div className="mt-6 flex flex-col gap-4 border-t border-white/[0.06] pt-6 sm:flex-row sm:items-center sm:justify-between">
      <div className="flex flex-wrap items-center gap-x-3 gap-y-2 text-sm">
        <span className="text-muted">© 2026 LookIntoHex</span>
        {MAIN_NAV.map(({ href, label }) => (
          <span key={href} className="flex items-center gap-3">
            <span className="text-white/15" aria-hidden>
              ·
            </span>
            <Link
              href={href}
              className="text-muted transition-colors hover:text-hex-400"
            >
              {label}
            </Link>
          </span>
        ))}
      </div>
      <DataRefreshButton iconOnly />
    </div>
  );
}

export default SecondaryFooter;
